import React from 'react'
import { Checkbox } from '@fielded/shared-ui'
import { SHIPMENT_STATUS } from '@fielded/fs-api/lib/shipment/constants'

import PSMDriverDeliveryCard from './PSMDriverDeliveryCard'
import { getPSMDriverDeliveryTitle } from './utils'

const PSMDriverDeliveryCardContainer = ({
  history,
  showCompleted,
  programs,
  filteredShipments,
  selectedDeliveriesIds,
  packedDeliveriesIds,
  newDeliveriesIds,
  onToggleCheckbox,
  isPsmResellerWarehouse,
  isWarehouseUser,
  canPsmResellerWarehouseUserMoveToPacked
}) => {
  // Count shipments with enabled checkboxes (for "Select all" functionality)
  // Note: Disabled checkboxes are still shown but cannot be selected
  const shipmentsWithEnabledCheckboxes = filteredShipments.filter(shipment => {
    if (showCompleted) return false
    if (isPsmResellerWarehouse && !canPsmResellerWarehouseUserMoveToPacked) return false

    // Only warehouse users (or reseller warehouse users with the feature) are "warehouse-like"
    // Drivers should always use PACKED status, regardless of feature flags
    const isWarehouseLike = isWarehouseUser || (isPsmResellerWarehouse && canPsmResellerWarehouseUserMoveToPacked)
    const statusToUse = isWarehouseLike ? SHIPMENT_STATUS.NEW : SHIPMENT_STATUS.PACKED
    const isCheckboxDisabled = isWarehouseLike
      ? (!shipment.routeId || shipment.status !== statusToUse)
      : shipment.status !== statusToUse

    return !isCheckboxDisabled
  })

  const selectableDeliveryIds = shipmentsWithEnabledCheckboxes.map(s => s.snapshotId)

  // Wrapper for onToggleCheckbox that uses selectableDeliveryIds instead of packedDeliveriesIds
  // This ensures "Select all" only selects shipments with enabled checkboxes
  const handleToggleCheckbox = (event, delivery = null) => {
    if (!delivery && event.target) {
      // "Select all" case - use selectableDeliveryIds instead of packedDeliveriesIds
      const isChecked = event.target.checked
      // Pass selectableIds in the event so parent can use it
      const modifiedEvent = {
        ...event,
        selectableIds: isChecked ? selectableDeliveryIds : []
      }
      onToggleCheckbox(modifiedEvent, null)
    } else {
      // Individual checkbox case - pass through as normal
      onToggleCheckbox(event, delivery)
    }
  }
  const hasSelectedAllPackedDeliveries = selectableDeliveryIds.length > 0 &&
    selectableDeliveryIds.length === selectedDeliveriesIds.length &&
    selectableDeliveryIds.every(id => selectedDeliveriesIds.includes(id))

  return (
    <section>
      {shipmentsWithEnabledCheckboxes.length > 0 && !showCompleted && (!isPsmResellerWarehouse || canPsmResellerWarehouseUserMoveToPacked) && (
        <section className='vs-u-margin-top'>
          <Checkbox.Stateless
            className='driver-delivery-card-container__select-all'
            label='Select all'
            checked={hasSelectedAllPackedDeliveries}
            onChange={event => handleToggleCheckbox(event)}
          />
        </section>
      )}

      <section>
        {filteredShipments.map(shipment => {
          const { title: headerTitle } = getPSMDriverDeliveryTitle(shipment)
          const isSelected = selectedDeliveriesIds.includes(shipment.snapshotId)
          return (
            <PSMDriverDeliveryCard
              key={shipment.snapshotId}
              shipment={shipment}
              headerTitle={headerTitle}
              history={history}
              programs={programs}
              showCompleted={showCompleted}
              isDeliverySelected={isSelected}
              onToggleCheckbox={event => onToggleCheckbox(event, shipment)}
              hideCheckbox={isPsmResellerWarehouse && !canPsmResellerWarehouseUserMoveToPacked}
              isDriver={!isWarehouseUser && !canPsmResellerWarehouseUserMoveToPacked}
              isWarehouseUser={isWarehouseUser}
              canPsmResellerWarehouseUserMoveToPacked={canPsmResellerWarehouseUserMoveToPacked}
            />
          )
        })}
      </section>
    </section>
  )
}

export default PSMDriverDeliveryCardContainer
